import { useQuery } from "@blitzjs/rpc"
import getCurrentUser from "app/users/queries/getCurrentUser"
import { useEffect } from "react"
import { Tracking } from "app/core/tracking"

export const useCurrentUser = () => {
  const [user] = useQuery(getCurrentUser, null, { staleTime: 1000 * 60 * 5 })

  useEffect(() => {
    if (user) {
      Tracking.setUserId(user.id)
      Tracking.setEmail(user.email)
    }
  }, [user])

  return user
}
